import { TSharedUtils } from 'gcf-player/shared-utils';
import { useEffect, useState } from 'react';

export function useSharedUtilsFromGcfPlayer() {
  const [utils, setUtils] = useState<TSharedUtils>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function loadUtils() {
      try {
        const sharedUtils = await import('gcf-player/shared-utils');
        setUtils(sharedUtils.default);
        setError(null);
      } catch (err) {
        setError(err as Error);
        console.error('Failed to load shared utils:', err);
      } finally {
        setLoading(false);
      }
    }

    if (window.environment.urls.gcfPlayerUrl) {
      loadUtils();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.environment.urls.gcfPlayerUrl]);

  return { utils, loading, error };
}
